const tr = {
  // 操作
  addProduct: "新增商品",

  code: "存貨編碼",
  name: "存貨名稱",
  uom: "主計量單位",
  cbm: "立方米",
  brand1: "型號1",
  brand2: "型號2",

  // 表單
  plCode: "請輸入存貨編碼",
  plCodeRule: "存貨編碼長度最少為{{min}}位，最多為{{max}}位。",
  plName: "請輸入存貨名稱",
  plInputMaxRule: "存貨名稱最多不超過{{length}}個字。",
  plCbm: "請輸入立方米",
  plDesc: "請輸入描述",
  plBrand1: "請輸入型號1",
  plBrand2: "請輸入型號2",
  plUom: "請選擇主計量單位",

  category: "所屬類目",
  addFailed: "新增失敗",
  modifySuccess: "修改成功",
  modifyFailed: "修改失敗",
  addChildNode: "新增子節點",
  clickModify: "點擊修改",
  serialNum: "序號",
  addCategory: "新增分類",
  addType: "新增商品種類",
  selProduct: "請選擇商品",
  priPrducInfo: "列印商品資訊",
  priThisPage: "列印該頁內容",
  modify: "修改",
  plFill: "請填寫必填項目！",
  modifyProduct: "修改商品",
  process: "工序",
  processPl: "請選擇工序",
  materialProcess: "物料制程",
  cbmDecimalLength: "小數位數不能超過{{count}}位元",

  gallery: '圖庫',
  folder: '資料夾',
  dataError: '數據錯誤，請聯系管理員修改資料後再試',
  productInfo: ' 產品資訊',
  num: ' 存貨數量',
  model: '存貨型號',
  preReady: '常備物品',
  isTrue: '是',
  isFalse: '否',
  isDeprecated: '是否廢棄',
  deprecated: '廢棄',
  normalStatus: '正常',
  notSet: '未設定',
  returnQuantity: "退庫數量",
  noReturnQuantity: "沒有退貨商品",

  // 生產資料
  createProductInfo: "創建生產資料",
  editProductInfo: "編輯生產資料",
  viewProductInfo: "查看生產資料",
  selectSaleOrder: "選擇銷售訂單",
  orderNumber: "訂單號",
  erpCode: "ERP料號",
  issueDate: "發布日期",
  customerName: "客戶名稱",
  customerModel: "客戶型號",
  companyModel: "公司型號",
  productionSoftware: "生產軟件",
  flash: "Flash軟件",
  md5Value: "MD5值",
  checksum: "校驗和",
  qaToolVersion: "QA工具版本",
  softwareVersion: "軟件版本",
  macAddressContent: "MAC地址內容",
  quantity: "數量",
  size: "尺寸",
  antivirusStatus: "殺毒狀態",
  languageRequirement: "語言要求",
  ssid: "SSID",
  initialIp: "初始IP",
  finishedToolVersion: "成品工具版本",
  semiFinishedToolVersion: "半成品工具版本",
  channelRange: "信道範圍",
  channelSelection: "信道選擇",
  defaultChannel: "默認信道",
  functionDescription: "功能描述",
  productionTestProgram: "生產測試程序",
  power: "功率",
  evm: "EVM",
  fer: "FER",
  smt: "SMT",
  dip: "DIP",
  test1: "測試1",
  assy: "組裝",
  test2: "測試2",
  pack: "包裝",
  shipmentRequirements: "發貨要求",
  plSelectSaleOrder: "請選擇銷售訂單",
  attachments: "附件圖片",
  uploadImage: "上傳圖片",
  plUploadImage: "請上傳圖片",
  uploadFailed: "上傳失敗",
  imageSelected: "已選擇圖片",
  onlyImageAllowed: "只允許上傳圖片",
  clickOrDragUpload: "點擊或拖動文件到此處上傳",
  descriptionPlaceholder: "描述（可選）",
  addAttachment: "添加附件圖片",
  languageZh: "中",
  languageEn: "英",
  languageTr: "繁",
  languageVn: "越南語",
  languageKo: "韓",
  languageFr: "法",
  languageDe: "德",
  languageRu: "俄",
  languageAdaptive: "自適應",
  languagePortuguese: "葡萄牙，其他",
  region36to165: "區域36-165",
  basicInfo: "基本資訊",
  productionInfo: "生產資訊",
  testInfo: "測試資訊",
  shipmentInfo: "發貨資訊",
  delete: "刪除",
  basicInfoDesc: "基本資料說明",
  testProgram: "產測程序",
  testProgramFinished: "產測程序-成品工具版本",
  testProgramSemiFinished: "產測程序-半成品工具版本",
  auto: "自動",
  addSuccess: "創建成功",
  addSuccessDesc: "生產資料已成功創建",
  editSuccess: "更新成功",
  editSuccessDesc: "生產資料已成功更新",
  editFailed: "更新失敗",
  saleOrderAlreadyHasProductInfo: "銷售單號：{{orderNumber}}，已創建生產資料",

  // 列表頁面
  normalTab: "正常",
  disabledTab: "禁用",
  salesOrderNumber: "銷售訂單號",
  internalNumber: "內部單號",
  createdAt: "創建時間",
  updatedAt: "更新時間",
  action: "操作",
  disable: "禁用",
  enable: "啟用",
  disableConfirm: "禁用確認",
  enableConfirm: "啟用確認",
  disableConfirmDesc: "確定要禁用生產資料嗎？",
  enableConfirmDesc: "確定要啟用生產資料嗎？",
  disableSuccess: "禁用成功",
  enableSuccess: "啟用成功",
  disableFailed: "禁用失敗",
  enableFailed: "啟用失敗",
  searchPlaceholder: "請輸入產品ID或說明書名稱搜索",
  batchExport: "批量導出",
  minStockCount: "最小庫存",
  maxStockCount: "最大庫存",
  minStockAgeDays: "最小庫齡(天)",
  maxStockAgeDays: "最大庫齡(天)",
  codePl: "輸入料號",
  alertAdd: "添加預警信息",
  alertDetail: "預警信息",
  overMaxCount: "超出庫存上限：{{maxStockCount}}",
  lowerMinCount: "低於庫存下限：{{minStockCount}}",
  alert: "預警",
  hh: "恆濕",
  ht: "恆溫",
  va: "真空",
  ot: "其他",
  storeType: "儲存要求",
  storageCode: "要求類型",
  minValue: "下限",
  maxValue: "上限",
  unit: "單位",
  inspectionCycleDays: "巡檢週期(天)",
};

export default tr;
